module.exports = __webpack_public_path__ + "img/1f413.246819e.svg";